export enum ROUTES {
  HOME = '/',
  LOGIN = '/login',
  MY_TEAMS = '/my-teams',
  RESUME_BUILDER_LIST = '/resume-builder',
  RESUME_BUILDER_EDITOR = '/resume-builder/editor',
}
